/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const labelEnumSchema = z.enum(["home", "work", "other"]).describe("* `home` - Дом\n* `work` - Работа\n* `other` - Другое");
